import Action from './Action';
import Logo from './Logo';

import { AppRoutes } from '@/interfaces/routes/AppRoutes';

export default function NavBar() {
	return (
		<div className="sticky top-0 inset-x-0 z-50">
			<header className="relative h-17 mx-auto duration-200 bg-white pt-3">
				<nav className="flex items-center justify-between w-full h-full px-8 py-1">
					<div className="flex-1 basis-0 h-full items-center">
						<Logo href={AppRoutes.Landing} width={200} height={100} />
					</div>
					<div className="flex items-center gap-x-6 h-full flex-1 basis-0 justify-end">
						<div className="flex items-center h-full">
							<Action />
						</div>
					</div>
				</nav>
			</header>
		</div>
	);
}
